import React from 'react'
// components
import AiResultActions from 'components/Modals/AiFieldValueModal/components/AiResultActions'
// views
import {
  ResultContent,
  ResultSection,
  ResultDisclaimer,
  ResultExplanation,
  ResultSectionLabel,
  ResultSectionValue
} from '../../views'

interface Props {
  value: string
  explanation: string
  onApply: () => void
  onTryAgain: () => void
}

const Result: React.FC<Props> = ({ value, explanation, onApply, onTryAgain }) => (
  <>
    <ResultContent>
      <ResultSection>
        <ResultSectionLabel>Generated Value</ResultSectionLabel>
        <ResultSectionValue>{value}</ResultSectionValue>
      </ResultSection>
      <ResultSection>
        <ResultSectionLabel>Explanation</ResultSectionLabel>
        <ResultExplanation>
          {explanation ||
            'rAI analyzed the field context and produced this suggestion. The value was derived from the provided prompt and relevant risk context available in the system.'}
        </ResultExplanation>
      </ResultSection>
      <ResultDisclaimer>rAI can make mistakes. Check important info.</ResultDisclaimer>
    </ResultContent>
    <AiResultActions onApply={onApply} onTryAgain={onTryAgain} />
  </>
)

export default Result
